import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKey = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "ic_24/Key",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20.3356 2.00001H19.1405C18.8125 1.99908 18.4876 2.06325 18.1846 2.18882C17.8816 2.31439 17.6066 2.49886 17.3754 2.73152L10.2791 9.8228C8.94162 9.36589 7.48881 9.37532 6.15734 9.84955C4.82588 10.3238 3.69421 11.2349 2.94668 12.4344C2.19915 13.6339 1.8798 15.0513 2.04066 16.4555C2.20151 17.8597 2.83309 19.1681 3.83252 20.1675C4.83194 21.1669 6.14032 21.7985 7.54454 21.9593C8.94875 22.1202 10.3661 21.8008 11.5656 21.0533C12.7651 20.3058 13.6762 19.1741 14.1505 17.8427C14.6247 16.5112 14.6341 15.0584 14.1772 13.7209L16.1745 11.7236V8.6577H18.6712V6.16107H21.6263C21.8693 5.77031 21.9987 5.31962 22 4.85949V3.66443C22 3.223 21.8246 2.79965 21.5125 2.48751C21.2004 2.17537 20.777 2.00001 20.3356 2.00001ZM6.60408 18.6442C6.35719 18.6442 6.11584 18.571 5.91056 18.4339C5.70527 18.2967 5.54527 18.1017 5.45079 17.8736C5.35631 17.6455 5.33159 17.3945 5.37975 17.1524C5.42792 16.9102 5.54681 16.6878 5.72139 16.5132C5.89597 16.3386 6.1184 16.2198 6.36055 16.1716C6.6027 16.1234 6.85369 16.1481 7.08179 16.2426C7.3099 16.3371 7.50486 16.4971 7.64202 16.7024C7.77919 16.9077 7.8524 17.149 7.8524 17.3959C7.8524 17.727 7.72088 18.0445 7.48678 18.2786C7.25267 18.5127 6.93516 18.6442 6.60408 18.6442Z",
			fill: "white"
		})
	})
});
const ForwardRef = forwardRef(SvgKey);
export default ForwardRef;
